import { render, staticRenderFns } from "./MeetingTitlebar.vue?vue&type=template&id=87bea5d4&scoped=true&"
import script from "./MeetingTitlebar.vue?vue&type=script&lang=js&"
export * from "./MeetingTitlebar.vue?vue&type=script&lang=js&"
import style0 from "./MeetingTitlebar.vue?vue&type=style&index=0&id=87bea5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bea5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bea5d4')) {
      api.createRecord('87bea5d4', component.options)
    } else {
      api.reload('87bea5d4', component.options)
    }
    module.hot.accept("./MeetingTitlebar.vue?vue&type=template&id=87bea5d4&scoped=true&", function () {
      api.rerender('87bea5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MeetingTitlebar.vue"
export default component.exports